var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShovel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5171 2.53433C17.8046 1.82189 16.6495 1.82189 15.9371 2.53433L14.4628 4.00862C13.3432 5.12818 13.3432 6.94334 14.4628 8.0629L14.6471 8.2472L9.30275 13.5915L7.64423 11.933C7.23712 11.5259 6.57705 11.5259 6.16994 11.933L3.22135 14.8815C1.59288 16.51 1.59288 19.1502 3.22135 20.7787C4.84981 22.4071 7.49006 22.4071 9.11853 20.7787L12.0671 17.8301C12.4742 17.423 12.4742 16.7629 12.0671 16.3558L10.4085 14.6972L15.7528 9.35291L15.9371 9.53718C17.0566 10.6567 18.8718 10.6567 19.9914 9.53718L21.4657 8.0629C22.1781 7.35045 22.1781 6.19535 21.4657 5.4829L18.5171 2.53433ZM16.3182 7.70687C16.3141 7.70261 16.31 7.69839 16.3058 7.6942C16.3016 7.69002 16.2974 7.68589 16.2931 7.68182L15.5685 6.95718C15.0596 6.44829 15.0596 5.62322 15.5685 5.11433L17.0428 3.64005C17.1446 3.53827 17.3096 3.53827 17.4114 3.64005L20.3599 6.58861C20.4617 6.69039 20.4617 6.85541 20.3599 6.95718L18.8856 8.43147C18.3768 8.94036 17.5517 8.94036 17.0428 8.43147L16.3182 7.70687Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShovel);
export default __webpack_public_path__ + "static/media/shovel.d135b096dacfce0bbb9e0600c1fd96d1.svg";
export { ForwardRef as ReactComponent };